// extracted by mini-css-extract-plugin
export default {"errorPlaceholder":"CustomErrorTooltip_errorPlaceholder__LY6TD"};